import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {EnvironmentService} from "./environment.service";
import {
    ActionResult,
    ActionResultList,
    PagedFilter,
    LeagueCompetitorRoundResult, LeagueStandingsRace
} from "@model";
import {map, Observable} from "rxjs";
import {LeagueRoundResultsFilter} from "../model/league/league-round-results-filter";
import {LeagueRoundResultMeta} from "../model/league/league-round-result-meta";

@Injectable({providedIn: 'root'})
export class LeagueResultsService {

    constructor(private http: HttpClient, private environmentService: EnvironmentService) {}

    getCompetitorRoundResults(leagueId: number, filter: PagedFilter<LeagueRoundResultsFilter>): Observable<LeagueCompetitorRoundResult[]> {
        const url = `${this.environmentService.getApiUrl()}/api/league/round-results/${leagueId}`;
        return this.http.post<ActionResultList<LeagueCompetitorRoundResult[], number>>(url, filter).pipe(
            map(res => res?.result ?? [])
        );
    }

    getLeagueRoundResultsMeta(leagueId: number, raceId: number): Observable<LeagueRoundResultMeta | undefined> {
        const url = `${this.environmentService.getApiUrl()}/api/league/round-results/${leagueId}/meta/${raceId}`;
        return this.http.get<ActionResult<LeagueRoundResultMeta>>(url).pipe(
            map(res => res?.result)
        );
    }

    getAvailableRaces(leagueId: number): Observable<LeagueStandingsRace[]> {
        const url = `${this.environmentService.getApiUrl()}/api/league/round-results/${leagueId}/available-races`;
        return this.http.get<ActionResultList<LeagueStandingsRace[], number>>(url).pipe(
            map(res => res?.result ?? [])
        );
    }


    saveRoundResults(leagueId: number, raceId: number, results: LeagueCompetitorRoundResult[]): Observable<void> {
        const url = `${this.environmentService.getApiUrl()}/api/league/round-results/${leagueId}/${raceId}/save`;
        return this.http.post<void>(url, results);
    }

    applyRoundResultsToPublic(leagueId: number, raceId: number): Observable<boolean> {
        const url = `${this.environmentService.getApiUrl()}/api/league/round-results/${leagueId}/${raceId}/apply-public`;
        return this.http.post<ActionResult<boolean>>(url, {}).pipe(
            map(res => res?.result ?? false)
        );
    }

    hideRoundResultsFromPublic(leagueId: number, raceId: number): Observable<boolean> {
        const url = `${this.environmentService.getApiUrl()}/api/league/round-results/${leagueId}/${raceId}/hide-public`;
        return this.http.post<ActionResult<boolean>>(url, {}).pipe(
            map(res => res?.result ?? false)
        );
    }

    toggleRoundResultCountStatus(leagueId: number, raceId: number, competitorId: number, countStatus: number): Observable<boolean> {
        const url = `${this.environmentService.getApiUrl()}/api/league/round-results/${leagueId}/${raceId}/${competitorId}/count-status`;
        return this.http.post<ActionResult<boolean>>(url, countStatus).pipe(
            map(res => res?.result ?? false)
        );
    }
}